module.exports = __webpack_public_path__ + "a9a055787f019382aef67fd926f59f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/clubhouse4.png
// module id = 1085
// module chunks = 0